import Vue from 'vue';
import { TabIndex } from '@/shared/enums';
import { isKey, keyMap } from '@/shared/utils';

Vue.directive('accessibility-focus', {
  bind(el, binding) {
    el._handleKeydown = (event) => {
      if (isKey([keyMap.ENTER, keyMap.SPACE], event)) {
        event.preventDefault();

        if (binding.modifiers.stop) {
          event.stopPropagation();
        }

        if (binding.value && typeof binding.value === 'function') {
          binding.value(event);
        }
      }
    };

    el._handleClick = (event) => {
      event.preventDefault();

      if (binding.modifiers.stop) {
        event.stopPropagation();
      }

      if (binding.value && typeof binding.value === 'function') {
        binding.value(event);
      }
    };

    el.setAttribute('tabindex', TabIndex.ENABLED);
    el.addEventListener('keydown', el._handleKeydown);
    el.addEventListener('click', el._handleClick);
  },
  unbind(el) {
    el.removeAttribute('tabindex');
    el.removeEventListener('keydown', el._handleKeydown);
    el.removeEventListener('click', el._handleClick);
  },
});
